import React from 'react';
import './style.scss';
export const CustomCheckbox = ({ title, children, ...rest }) => {
  return (
    <div className="checkbox-wrapper-46">
      <input {...rest} type="checkbox" id="cbx-46" className="inp-cbx" />
      <label htmlFor="cbx-46" className="cbx d-flex align-items-center">
        <span>
          <svg viewBox="0 0 12 10" height="10px" width="12px">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
        {children}
      </label>
    </div>
  );
};
